<ion-app>
  <ion-header>
    <app-header *ngIf="currentUrl && currentUrl !== '/login' && currentUrl !== '/register' && currentUrl !== '/plan-de-salle'"></app-header>
  </ion-header>

  <ion-split-pane contentId="main" [class.no-margin]="currentUrl && (currentUrl === '/login' || currentUrl === '/register' || currentUrl === '/plan-de-salle')">
    <app-menu contentId="main" *ngIf="currentUrl && currentUrl !== undefined && currentUrl !== '/login' && currentUrl !== '/register' && currentUrl !== '/plan-de-salle'"></app-menu>

    <div class="ion-page" id="main">
      <ion-router-outlet *ngIf="currentUrl" 
      [class.controle-compte-partage]="comptePartage" 
      [class.margin-header]="currentUrl !== '/login' && currentUrl !== '/register' && currentUrl !== '/plan-de-salle'" 
      ></ion-router-outlet>
    </div>
    

  </ion-split-pane>
</ion-app>
